export const titlesTable = [
    'ID',
    'Название',
    'Дата последнего обновления',
    null,
];

export const FEED_GENERATION_STATUSES = {
    successful: 'SUCCESSFUL',
    failed: 'FAILED',
    inProgress: 'IN_PROGRESS',
} as const;
